export default [
    {
        path: '/finance/finance-journal',
        name: 'finance-journal',
        props: true,
        component: () => import('@/views/finance/journal/index.vue'),
        meta: {
            pageTitle: 'Journal',
            breadcrumb: [
                {
                text: 'Journal',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/finance-journal/add',
        name: 'create-finance-journal',
        component: () => import('@/views/finance/journal/create.vue'),
        meta: {
            pageTitle: 'Create Journal',
            breadcrumb: [
                {
                text: 'Journal',
                to: { name: 'finance-journal' },
                },
                {
                text: 'Create Journal',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/finance-journal/:id',
        name: 'detail-finance-journal',
        props: true,
        component: () => import('@/views/finance/journal/detail.vue'),
        meta: {
            pageTitle: 'Detail Journal',
            breadcrumb: [
                {
                text: 'Journal',
                to: { name: 'finance-journal' },
                },
                {
                text: 'Detail Journal',
                active: true,
                },
            ],
        },
    },
]